module.exports = __webpack_public_path__ + "static/media/race-room-off.bd4e930e.png";